export const LAMP_IMAGES = [
    '/image/lamp/lamp_yellow.png',
    '/image/lamp/lamp_orange.png',
    '/image/lamp/lamp_red.png',
    '/image/lamp/lamp_green.png',
    '/image/lamp/lamp_blue.png',
    '/image/lamp/lamp_purple.png',
];

export const LAMP_TITLES = [
    '身體健康',
    '家庭和樂',
    '道業成就', 
    '學業進步',
    '事業順利',
    '廣結善緣',
];
export const randomLampImage = () => LAMP_IMAGES[Math.floor(Math.random() * LAMP_IMAGES.length)];
export const getLampImageByTitle = (title) => {
    const titleIndex = LAMP_TITLES.indexOf(title);
    return LAMP_IMAGES[titleIndex >= 0 ? titleIndex : 0];
};

export const DEFAULT_PAGE_TITLE = {
    title: '光照大千',
    subtitle: '點燈完成',
};

export const DEFAULT_QUOTE = {
    text: '譬如一燈，燃百千燈\n冥者皆明，明終不盡',
    dedication: '願以此點燈功德  回向法界眾生',
};

export const DEFAULT_BLESSING_DATA = {
    // label: '法語開示',
    // title: '家庭和樂',
    // content: '中國有一句名言：「同船過渡都是百世修」，能成為夫妻就是一種緣，所以彼此之間要互相尊重、互相關心、互相照顧，從生到死都應該如此，因為這種褔報、這種善緣是不容易的。',
    // author: '惟覺安公老和尚',
};

export const DEFAULT_LAMP_INFO = {
    branch: '普天精舍',
    donor: '王大明',
};

// ─── 傳燈路線圖 各地區精舍數據 ───
// 點的順序為地圖上從左到右（西→東）排列，連線動畫依此順序繪製

export const TAICHUNG_ROUTE = {
    temples: [
        { id: 2, name: "普民精舍", lat: 24.1565545, lng: 120.6482568 },
        { id: 1, name: "普真精舍", lat: 24.1715126, lng: 120.6611726 },
        { id: 5, name: "普安精舍", lat: 24.1346688, lng: 120.6561296 },
        { id: 3, name: "普開精舍", lat: 24.1049038, lng: 120.6820395 },
        { id: 4, name: "普梵精舍", lat: 24.165091, lng: 120.6965833 },
    ],
    highlightCounties: ['台中市'],
    mainCounty: '台中市',
    label: '台中地區',
};

export const CHANGHUA_ROUTE = {
    temples: [
        { id: 1, name: "普竺精舍", lat: 23.7635438, lng: 120.7022412 },
        { id: 2, name: "普田精舍", lat: 23.7054157, lng: 120.5393395 },
        { id: 3, name: "普嘉精舍", lat: 23.4826834, lng: 120.4343782 },
        { id: 4, name: "普憲精舍", lat: 23.3195143, lng: 120.3207034 },
        { id: 5, name: "普門精舍", lat: 23.2267128, lng: 120.3476832 },
    ],
    highlightCounties: ['彰化縣', '南投縣', '雲林縣', '嘉義縣', "台南市", "嘉義市"],
    // mainCounty: '嘉義縣',
    label: '彰化南投地區',
};

export const OVERSEAS_ROUTE = {
    temples: [
        { id: 2, name: '泰佛寺', lat: 13.7563, lng: 100.5018 },  // Bangkok, Thailand
        { id: 4, name: '普廣精舍', lat: 22.3193, lng: 114.1694 },  // Hong Kong
        { id: 3, name: '海天精舍', lat: 14.5995, lng: 120.9842 },  // Manila, Philippines
        { id: 5, name: '普東精舍', lat: 35.6762, lng: 139.6503 },  // Tokyo, Japan
        { id: 1, name: '寶林禪寺', lat: -33.8688, lng: 151.2093 },  // Sydney, Australia

    ],
    highlightCounties: ['Thailand', 'China', 'Philippines', 'Japan', 'Australia'],
    mainCounty: '',
    geoJsonUrl: '/data/world-countries.geojson',  // 使用世界地圖
    label: '海外地區',
};

export const DEFAULT_LAMPS = [
    { record_id: 1, vower_name: '王大明', monastery_name: '普天精舍', title: '家庭和樂', serial_num: '2-1', displayable: true, created_at: '2026-01-15 10:30:00' },
    { record_id: 2, vower_name: '曾吉祥', monastery_name: '普覺精舍', title: '道業成就', serial_num: '3-1', displayable: true, created_at: '2026-01-16 14:20:00' },
    { record_id: 3, vower_name: '傳悟', monastery_name: '普民精舍', title: '身體健康', serial_num: '1-1', displayable: true, created_at: '2026-01-17 09:15:00' },
    { record_id: 4, vower_name: '張小芬', monastery_name: '普平精舍', title: '學業進步', serial_num: '4-1', displayable: true, created_at: '2026-01-18 16:45:00' },
    { record_id: 5, vower_name: '黃志明', monastery_name: '普德精舍', title: '事業順利', serial_num: '5-1', displayable: true, created_at: '2026-01-19 11:00:00' },
    { record_id: 6, vower_name: '林大為', monastery_name: '普善精舍', title: '廣結善緣', serial_num: '6-1', displayable: true, created_at: '2026-01-20 08:30:00' },
    { record_id: 7, vower_name: '陳小華', monastery_name: '普開精舍', title: '身體健康', serial_num: '1-2', displayable: true, created_at: '2026-01-21 13:10:00' },
    { record_id: 8, vower_name: '李明珠', monastery_name: '普慧精舍', title: '道業成就', serial_num: '3-2', displayable: true, created_at: '2026-01-22 15:25:00' },
    { record_id: 9, vower_name: '吳大成', monastery_name: '普光精舍', title: '家庭和樂', serial_num: '2-2', displayable: true, created_at: '2026-01-23 10:50:00' },
];
